// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__26q_a","notes":"Notes_notes__24kO1"};